import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EpcCertificateComponent } from './epc-certificate.component';



@NgModule({
  declarations: [EpcCertificateComponent],
  imports: [
    CommonModule
  ],
  exports: [EpcCertificateComponent]
})
export class EpcCertificateModule { }
